import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TabsModule } from 'ngx-bootstrap';
import { TagInputModule } from 'ngx-chips';
import { FourDotFivePhoneNumberModule } from 'src/app/shared/four-dot-five-phone-number/four-dot-five-phone-number.module';
import { InviteUserToMeetingComponent } from './invite-user-to-meeting.component';

@NgModule({
  declarations: [
    InviteUserToMeetingComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    TabsModule.forRoot(),
    TagInputModule,
    FourDotFivePhoneNumberModule
  ],
  exports: [
    InviteUserToMeetingComponent
  ]
})
export class InviteUserToMeetingModule { }
